import { Dialog } from "@inductiveautomation/ws-components";
import { useTranslation } from "react-i18next";

const ChangePasswordDialog = ({
  isOpen,
  email,
  onClose,
}: {
  isOpen: boolean;
  email: string;
  onClose: () => void;
}) => {
  const { t } = useTranslation("translation", { keyPrefix: "profile" });

  return (
    <Dialog
      testId={`profile-dialog-change-password`}
      isOpen={isOpen}
      headline={t("change_password_action.dialog_headline")}
      supportingText={t("change_password_action.dialog_description", { email })}
      actions={[]}
      onClose={onClose}
      showCloseButton
      confirmOnClose={false}
    />
  );
};

export default ChangePasswordDialog;
